import React from 'react';
import { Heart } from 'lucide-react';
import StripeDonationButton from '../components/StripeDonationButton';
import './Donations.css';

const Donations = () => {
  return (
    <div className="donations-page">
      <section className="page-hero">
        <div className="hero-container">
          <h1 className="page-title">Support Our Mission</h1>
          <p className="page-subtitle">Help Expand Access to Recovery Housing</p>
        </div>
      </section>

      <section className="page-content">
        <div className="content-container">
          <div className="donations-intro">
            <Heart size={56} className="intro-icon" />
            <h2 className="intro-title">Your Support Makes a Difference</h2>
            <p className="intro-text">
              Community support helps expand access to recovery housing and strengthen recovery support services.
            </p>
            <p className="intro-text">
              Individuals and organizations interested in supporting recovery housing initiatives may contribute through donations. Your support helps individuals in recovery who are working toward stability and independence.
            </p>
          </div>

          <div className="impact-section">
            <h2 className="section-heading">How Your Donation Helps</h2>
            <div className="impact-grid">
              <div className="impact-card">
                <div className="impact-number">1</div>
                <h3 className="impact-title">Provide Stable Housing</h3>
                <p className="impact-description">
                  Donations help maintain safe, structured recovery environments where residents can focus on their recovery journey.
                </p>
              </div>

              <div className="impact-card">
                <div className="impact-number">2</div>
                <h3 className="impact-title">Support Services</h3>
                <p className="impact-description">
                  Your contributions support essential services and resources that help residents rebuild their lives.
                </p>
              </div>

              <div className="impact-card">
                <div className="impact-number">3</div>
                <h3 className="impact-title">Expand Access</h3>
                <p className="impact-description">
                  Donations help us expand our capacity to serve more individuals seeking recovery housing.
                </p>
              </div>

              <div className="impact-card">
                <div className="impact-number">4</div>
                <h3 className="impact-title">Build Community</h3>
                <p className="impact-description">
                  Your support helps create a stronger recovery community with increased resources and opportunities.
                </p>
              </div>
            </div>
          </div>

          <div className="donation-cta">
            <h2 className="cta-title">Make a Donation Today</h2>
            <p className="cta-description">
              Every contribution, no matter the size, helps us continue our mission of providing safe, structured recovery housing for individuals rebuilding their lives.
            </p>
            
            <div className="donation-button-container">
              <StripeDonationButton />
            </div>
          </div>

          <div className="acknowledgment">
            <h3 className="acknowledgment-title">Thank You</h3>
            <p className="acknowledgment-text">
              We are grateful for the support of individuals and organizations who believe in our mission. Your generosity helps create opportunities for individuals in recovery to rebuild their lives with dignity and purpose.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Donations;
